import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { ANIMATION_DURATION_FADE_OUT } from './constants';
export var getDefaultStyleSheet = _ref => {
  var {
    animationState,
    breakpoint,
    designContext,
    disableAnimations,
    status,
    width
  } = _ref;
  var outerTopPadding = designContext.get('space/100').value();
  var rootPadding = designContext.get('space/200').value();
  var gap = designContext.get('space/100').value();
  var iconWidth = 20;
  var wideScreenBreakpoint = breakpoint && breakpoint + 2 * rootPadding + gap + iconWidth;
  var wideScreen = width && wideScreenBreakpoint && width > wideScreenBreakpoint;
  return {
    rootStyle: {
      backgroundColor: designContext.get('takeover/background-color', {
        status
      }).toString(),
      borderRadius: designContext.get('takeover/corner-radius').value(),
      flexDirection: 'row',
      padding: rootPadding,
      gap
    },
    iconWrapperStyle: _objectSpread({
      flexDirection: 'row',
      justifyContent: 'flex-end'
    }, wideScreen ? {
      flexGrow: 1,
      // Making up for gap + close icon on the right that should be ignored when centering left icon + content:
      paddingLeft: gap + iconWidth
    } : {}),
    contentWrapperStyle: _objectSpread({
      flexDirection: 'column'
    }, wideScreen && width > wideScreenBreakpoint + gap + iconWidth ? {
      width: breakpoint - gap - iconWidth
    } : {
      flexShrink: 1,
      flexGrow: 1
    }),
    closeWrapperStyle: _objectSpread({
      flexDirection: 'row',
      justifyContent: 'flex-end'
    }, wideScreen ? {
      flexGrow: 1
    } : {}),
    portalStyle: {
      opacity: animationState === 'fade-out' ? 0 : 1,
      transition: disableAnimations ? undefined : "opacity ".concat(ANIMATION_DURATION_FADE_OUT, "ms"),
      // DialogUnwrapped has zIndex 2147483647,
      // so we need to use the same here in order to have the Takeover rendered on top of it
      zIndex: 2147483647,
      position: 'fixed',
      top: outerTopPadding,
      left: 0,
      right: 0
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map